import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getConditionRows } from "./condition-rows";

export const metadata = {
  tableType: "Condition",
  displayName: "Conditions",
  getRows: (bundle: FhirBundleSdk) => getConditionRows({ bundle }),
  getSearchableText: (row: Record<string, unknown>) => {
    // Only include fields that are visible in the table:
    // Condition, Code, First Seen, Last Seen
    const searchableFields = ["condition", "code", "firstSeen", "lastSeen"];

    const rowValues = searchableFields
      .map(key => String(row[key] ?? ""))
      .filter(val => val && val !== "-")
      .join(" ");

    return rowValues.toLowerCase();
  },
};
